// Centrální registr i18n manifestů – composition bod pro app bootstrap a testy
// Skládá veřejné i18n manifesty slice bez přímých importů JSONů

import type { SliceI18nManifest } from '@/shared/lib/vsa';

import { notFoundI18nManifest } from '@/modules/not-found/i18nManifest';
import { plannerI18nManifest } from '@/modules/planner/i18nManifest';
import { columbusI18nManifest } from '@/modules/columbus-planner/i18nManifest';
import { securityI18nManifest } from '@/modules/security/i18nManifest';
import { reservationsI18nManifest } from '@/modules/reservations/i18nManifest';
import { productsI18nManifest } from '@/modules/products/i18nManifest';
import { codebooksI18nManifest } from '@/modules/codebooks/i18nManifest';
import { windowOnboardingI18nManifest } from '@/modules/window-onboarding/i18nManifest';
import { authI18nManifest } from '@/shared/auth/i18nManifest';
import { commonI18nManifest } from '@/shared/common/i18nManifest';
import { errorsI18nManifest } from '@/shared/errors/i18nManifest';
import { navigationI18nManifest } from '@/shared/navigation/i18nManifest';
import { sharedUiI18nManifest } from '@/shared/ui/i18nManifest';
import { asyncSelectorI18nManifest } from '@/shared/ui/async-selector/i18nManifest';
import { listPageI18nManifest } from '@/shared/ui/list-page/i18nManifest';
import { archivalI18nManifest } from '@/shared/archival/i18nManifest';

/** Všechny slice-owned i18n manifesty pro app a test composition */
export const sliceI18nManifests: readonly SliceI18nManifest[] = [
  authI18nManifest,
  commonI18nManifest,
  errorsI18nManifest,
  notFoundI18nManifest,
  plannerI18nManifest,
  columbusI18nManifest,
  securityI18nManifest,
  reservationsI18nManifest,
  productsI18nManifest,
  codebooksI18nManifest,
  windowOnboardingI18nManifest,
  navigationI18nManifest,
  sharedUiI18nManifest,
  asyncSelectorI18nManifest,
  listPageI18nManifest,
  archivalI18nManifest,
];
